import * as React from 'react';

type Props = {
  stepIndex: number,
  stepCount: number
};

const StepCounter = (
  {
    stepIndex,
    stepCount
  }: Props
): JSX.Element => (
  <section
    className="step-counter"
    data-qa="step-counter"
  >
    {
      stepIndex > 0 && (
        <React.Fragment>
          <div
            key={`current-count-${stepIndex}`}
            className="step-counter--current"
            data-qa="step-counter--current"
          >
            {stepIndex}
          </div>
          <div
            className="step-counter--total"
            data-qa="step-counter--total"
          >
            /{stepCount}
          </div>
        </React.Fragment>
      )
    }
  </section>
);

export default StepCounter;
